import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { DataService } from '@app/shared/common/auth/data.service';
import { openSupportEmail } from '@app/shared/common/support/contact-support';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { ProductDetail } from '@shared/service-proxies/stripe-service-proxy';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'vf-subscription-trial-ended-modal',
  templateUrl: './subscription-trial-ended-modal.component.html'
})
export class SubscriptionTrialEndedModalComponent extends AppComponentBase implements OnInit {

  @ViewChild('subscriptionTrialEndedModal') modal: ModalDirective;
  @Output() openSBillingDetail: EventEmitter<any> = new EventEmitter<any>();
  @Output() openBillingDetailsEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() openAdjustUsersFromUpgradeEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() openAdjustUsersEmit: EventEmitter<any> = new EventEmitter<any>();
  isFromBanner: boolean;
  yearPlans: Array<any> = new Array<any>();
  monthPlans: Array<any> = new Array<any>();
  selectedPlanId: number;
  productDetail: ProductDetail[];
  isbtnDisable = true;

  yearRate = 190;
  qtrlyRate = 19;
  yearRatePerUser = 190;
  qtrlyRatePerUser = 19;
  isLoading = false;
  isMobile = false;
  constructor(injector: Injector,
    private dataService: DataService,
    private _userService: UserServiceProxy) {
    super(injector);
  }

  ngOnInit() {
    if (window.innerWidth < AppConsts.mobileScreenWidth) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  private buildStaticProductDetails(activeUserCount: number): void {
    // Annual / Professional plan
    const annualPlan = new ProductDetail({
      name: 'Professional',
      price: 190,
      currency: 'usd',
      interval: 'year',
      intervalCount: 1,
      unit: 'user/year',
      noOfUsers: activeUserCount
    });

    // Monthly / Starter plan
    const monthlyPlan = new ProductDetail({
      name: 'Starter',
      price: 19,
      currency: 'usd',
      interval: 'month',
      intervalCount: 1,
      unit: 'user/month',
      noOfUsers: activeUserCount
    });

    this.productDetail = [annualPlan, monthlyPlan];
    this.yearPlans = [annualPlan];
    this.monthPlans = [monthlyPlan];
    this.selectedPlanId = 0; // 0 - Annually, 1 - Monthly
  }

  private loadProductDetails(): void {
    this.isLoading = true;
    this._userService.getTenantUsers().subscribe(result => {
      this.isLoading = false;
      let activeUserCount = 0;
      if (!result.isError && result.responseData) {
        activeUserCount = result.responseData.length;
      }
      this.buildStaticProductDetails(activeUserCount);
    });
  }

  show(item?: boolean): void {
    if (!this.isMobile) {
      this.isFromBanner = item;
      this.modal.show();
      this.updateBodyForCenterModalShow();
      this.loadProductDetails();
    }
  }

  close() {
    this.modal.hide();
    this.updateBodyForCenterModalHide();
    this.closeEmit.emit();
  }

  closeBeforeActions() {
    this.modal.hide();
    this.updateBodyForCenterModalHide();
    this.closeEmit.emit();
    this.dataService.showBanner.next();
  }

  showBillingDeatil(type: string): void {
    let isIframe = window !== window.parent && !window.opener;

    if (isIframe) {
        window.open('https://app.trovve.com', '_blank');
    } else {
      if (type === 'MONTHLY') {
        this.selectedPlanId = 1;
      } else {
        this.selectedPlanId = 0;
      }

      // Both plans support minimum 2 and maximum 50 users
      let selectedPlan = this.productDetail[this.selectedPlanId];
      if (selectedPlan.noOfUsers > 50) {
        this.modal.hide();
        this.updateBodyForCenterModalHide();
        if (!this.isFromBanner) {
          this.openAdjustUsersFromUpgradeEmit.emit([this.productDetail, this.selectedPlanId, this.isFromBanner]);
        } else {
          this.openAdjustUsersEmit.emit([this.productDetail, this.selectedPlanId, this.isFromBanner]);
        }
        return;
      }

      this.modal.hide();
      this.updateBodyForCenterModalHide();
      if (!this.isFromBanner) {
        this.openBillingDetailsEmit.emit([this.productDetail, this.selectedPlanId, this.isFromBanner]);
      } else {
        this.openSBillingDetail.emit([this.productDetail, this.selectedPlanId, this.isFromBanner]);
      }
      this.closeEmit.emit();
    }
  }

  planChanged(): void {
    this.selectedPlanId = this.selectedPlanId === 0 ? 1 : 0;
  }

  sendSupportMail(): void {
    openSupportEmail();
  }

}
